import { render, staticRenderFns } from "./ModalPromotion.vue?vue&type=template&id=73c7bade&scoped=true&"
import script from "./ModalPromotion.vue?vue&type=script&lang=js&"
export * from "./ModalPromotion.vue?vue&type=script&lang=js&"
import style0 from "./ModalPromotion.vue?vue&type=style&index=0&id=73c7bade&prod&lang=scss&scoped=true&"
import style1 from "./ModalPromotion.vue?vue&type=style&index=1&id=73c7bade&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c7bade",
  null
  
)

export default component.exports